import api from '~/services/api'
import newEventPost from './newPosts/newEventPost'
import newAlertPost from './newPosts/newAlertPost'

export const createNewPost = async (
  projectId,
  postType,
  { post, ...params }
) => {
  let postBody = {
    ...post,
    languageCode: 'pt-BR',
    media: [post.media],
  }

  if (post?.event && post?.topicType !== 'OFFER')
    postBody = newEventPost(postBody)
  if (post.callToAction) postBody = newAlertPost(postBody)

  const body = {
    post: postBody,
    ...params,
  }

  return api.post(`/projects/${projectId}/posts/${postType}`, body)
}
